import { useEffect, useState } from "react";
import { getRequest } from "helpers/utility/axiosServiceLayer";
import { composeApiURL } from "helpers/utility/axiosHelpers";
import { FilterOptions } from "./types";

const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

const EMPTY: FilterOptions = { jobs: [], setups: [], lots: [] };

/**
 * Loads the job / setup / lot suggestion lists once.
 *
 * They are small (tens of values) and change only when new scans are ingested, so they
 * are fetched on mount and filtered client-side rather than queried per keystroke.
 */
export default function useFilterOptions() {
  const [options, setOptions] = useState<FilterOptions>(EMPTY);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const url = composeApiURL(HOST_URL, "/scan-results/filter-options");
        const data = await getRequest<FilterOptions & { enabled: boolean }>(
          url,
          {
            signal: controller.signal,
          },
        );
        // Do not trust the shape: a partial payload must not leave the inputs with
        // undefined option lists, which would crash the dropdown.
        setOptions({
          jobs: data.jobs ?? [],
          setups: data.setups ?? [],
          lots: data.lots ?? [],
        });
      } catch {
        // Suggestions are a convenience; without them the inputs still take free text.
        setOptions(EMPTY);
      }
    })();
    return () => controller.abort();
  }, []);

  return options;
}
